import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import { installChunkErrorGuard } from './utils/lazyRetry';
import './index.css';
import './design.css';

installChunkErrorGuard();

if (process.env.REACT_APP_SENTRY_DSN) {
  const EXT_SCHEME = /^(chrome|moz|msb|brave|safari)-ext:\/\//;
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: ['Extension context invalidated.'],
    // Drop events whose entire stack comes from browser extensions;
    // mixed stacks (containing our own frames) are kept for triage.
    beforeSend: (event) => {
      const values = event.exception?.values || [];
      const frames = values.flatMap((v) => v.stacktrace?.frames || []);
      if (frames.length && frames.every((f) => EXT_SCHEME.test(f.filename || ''))) {
        return null;
      }
      return event;
    },
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

console.log('SYNOTI_BUILD_VERSION=v8_CACHE_BUSTED');
const root = createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);
